import { Box, styled } from "@mui/material";
import { colors } from "../../../styles/theme";

export const BannerContainer = styled(Box)(({ theme }) => ({
  backgroundSize: "cover",
  backgroundPosition: "center",
  borderRadius: "15px",
  position: 'relative',
  border: `1px solid ${colors.text.v4}`,
  zIndex: 2,
  '&::before': {
    content: "'Loading...'",
    color: colors.text.v4,
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%)',
    zIndex: 1,
  }
}));